import { useEffect, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Devices/ImportConfiguration.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
const ImportConfiguration = ({accessToken,selectedConfigurationTemplate,setSelectedConfigurationTemplate,showImportConfiguration,setShowImportConfiguration}) =>{
    const [configurationTemplates,setConfigurationTemplates] = useState(null);
    const [selectedConfigurationTemplateId,setSelectedConfigurationTemplateId] = useState('');
    const fetchConfigurationTemplates = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/devices/configurations/templates/all/get`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${accessToken}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setConfigurationTemplates(responseData);
            }
        }
        catch(error){
            console.error(error);
        }
    };
    useEffect(() =>{
        const fetchTemplates = async() =>{
            if(showImportConfiguration) await fetchConfigurationTemplates();
            else setSelectedConfigurationTemplateId('');
        };
        fetchTemplates();
    },[showImportConfiguration]);
    const assignSelectedConfigurationTemplate = () =>{
        if(!configurationTemplates) return;
        configurationTemplates.forEach(configurationTemplate =>{
            if(configurationTemplate.id === Number(selectedConfigurationTemplateId)) setSelectedConfigurationTemplate(configurationTemplate);
        });
    };
    if(!showImportConfiguration) return null;
    return(
        <div className="import-device-configuration-container">
            <div className="import-device-configuration-header">
                <h3>Import configuration</h3>
                <p onClick={() => setShowImportConfiguration(false)}>&#10006;</p>
            </div>
            <div className="import-device-configuration-body">
                <select
                    value={selectedConfigurationTemplateId}
                    onChange={(e) => setSelectedConfigurationTemplateId(e.target.value)}>
                    <option value={''} disabled>Select configuration</option>
                    {configurationTemplates && configurationTemplates.map(configurationTemplate => (
                        <option
                            key={configurationTemplate.id}
                            value={configurationTemplate.id}>{configurationTemplate.name}</option>
                    ))}
                </select>
            </div>
            <div className="import-device-configuration-buttons-container">
                <button onClick={() => {
                    setSelectedConfigurationTemplate(null);
                    setShowImportConfiguration(false);
                }}>Cancel</button>
                <button onClick={() =>{
                    assignSelectedConfigurationTemplate();
                    setShowImportConfiguration(false);
                }}>Import</button>
            </div>
        </div>
    );
};
export default ImportConfiguration;